import { createFileRoute } from "@tanstack/react-router";

import { ContractPage } from "../../../workspaces/library/pages/ContractPage";

export const Route = createFileRoute("/_console/p/$org/$project/library/contracts/$id")({
  component: ContractRoute,
});

/** One contract a dataset's episodes are held to — `sx.episode/v9`. */
function ContractRoute() {
  const { id } = Route.useParams();
  return <ContractPage id={id} />;
}
